/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { Link, useLocation } from '@reach/router';
import {AuthContext} from '../../AuthContext';
import _ from 'lodash';
import { Divider } from 'antd'

import SystemUserAvatar from '../Custom/SystemUserAvatar';

const Index = () => {

    const { userData } = useContext(AuthContext);
    const location = useLocation();

    return (
        <aside class="aside-container">
            <div class="aside-inner">
                <nav class="sidebar" data-sidebar-anyclick-close="">
                    <ul class="sidebar-nav">
                        <li class="has-user-block">
                            <div id="user-block">
                                <div class="item user-block">
                                    <div class="user-block-picture">
                                        <div class="user-block-status">
                                            <SystemUserAvatar className="img-thumbnail rounded-circle" size={65} empid={userData.empid} imgurl={userData.imgurl} alt="Avatar" />
                                            {/* <div class="circle bg-success circle-lg"></div> */}
                                        </div>
                                    </div>
                                    <div class="user-block-info">
                                        <span class="user-block-name">{userData.full_name ? userData.full_name : `${userData.first_name} ${userData.last_name}`}</span><span class="user-block-role">{userData.user_type}</span>
                                    </div>
                                    <div class="user-block-info">
                                        <span class="user-block-name">{userData.designationname ? userData.designationname : null}</span><span class="user-block-role">{userData.role}</span>
                                    </div>
                                    <Divider type='horizontal'/>
                                </div>
                            </div>
                        </li>
                        {/* <li class="nav-heading ">
                            <span data-localize="sidebar.heading.HEADER">Main Navigation</span>
                        </li> */}
                        <li class={_.isEqual(location.pathname, '/') ? 'active' : null}>
                            <Link to="/" title="Dashboard">
                                <em class="icon-graph"></em><span data-localize="sidebar.nav.WIDGETS">Dashboard</span>
                            </Link>
                        </li>
                        {/* <li class=" active"><a href="#dashboard" title="Dashboard" data-toggle="collapse">
                            <div class="float-right badge badge-success">3</div><em class="icon-speedometer"></em><span data-localize="sidebar.nav.DASHBOARD">Dashboard</span>
                            </a>
                            <ul class="sidebar-nav sidebar-subnav collapse show" id="dashboard">
                                <li class="sidebar-subnav-header">Dashboard</li>
                                <li class=" active"><a href="dashboard.html" title="Dashboard v1"><span>Dashboard v1</span></a></li>
                                <li class=" "><a href="dashboard_v2.html" title="Dashboard v2"><span>Dashboard v2</span></a></li>
                                <li class=" "><a href="dashboard_v3.html" title="Dashboard v3"><span>Dashboard v3</span></a></li>
                            </ul>
                        </li> */}
                        {
                            userData.isSuperAdmin &&
                            <li class={_.isEqual(location.pathname, '/user-administration') ? 'active' : null}>
                                <Link to="/user-administration" title="Users">
                                    <em class="icon-user"></em><span data-localize="sidebar.nav.WIDGETS">User Management</span>
                                </Link>
                            </li>
                        }
                        {
                            (userData.isSuperAdmin || 
                            _.isEqual(userData.role, 'Admin') || 
                            _.includes([
                                'Chief Executive Officer',
                                'Chief Operating Officer'
                            ], userData.designationname) || 
                            _.includes([
                                'Sales User'
                            ], userData.role)) &&
                            <li class={(_.isEqual(location.pathname, '/printing-order') || (location.pathname.indexOf('printing-order') !== -1)) ? 'active' : null}>
                                <Link to="/printing-order" title="Printing Order">
                                    <em class="fa-1x mr-1 fas fa-columns"></em><span data-localize="sidebar.nav.WIDGETS">Printing Order</span>
                                </Link>
                            </li>
                        }
                        {
                            //(userData.isSuperAdmin || 
                            //_.isEqual(userData.role, 'Admin')) &&
                            <li class={(_.isEqual(location.pathname, '/job-order') || (location.pathname.indexOf('job-order') !== -1)) ? 'active' : null}>
                                <Link to="/job-order" title="Job Order">
                                    <em class="fa-1x mr-1 fas fa-tasks"></em><span data-localize="sidebar.nav.WIDGETS">Job Order</span>
                                </Link>
                            </li>
                        }
                        {
                            (userData.isSuperAdmin || 
                            _.isEqual(userData.role, 'Admin') || 
                            _.includes([
                                'Chief Executive Officer',
                                'Chief Operating Officer'
                            ], userData.designationname)) &&
                            <li class={_.isEqual(location.pathname, '/audit-trail') ? 'active' : null}>
                                <Link to="/audit-trail" title="Audit Trail">
                                    <em class="fa-1x icon-list mr-2"></em><span data-localize="sidebar.nav.WIDGETS">Audit Trail</span>
                                </Link>
                            </li>
                        }
                        {
                            (userData.isSuperAdmin || 
                            _.isEqual(userData.role, 'Admin')) &&
                            <li class={(_.isEqual(location.pathname, '/settings') || (location.pathname.indexOf('settings') !== -1)) ? 'active' : null}>
                                <Link to="/settings" title="Settings">
                                    <em class="fa-1x mr-1 fas fa-cogs"></em><span data-localize="sidebar.nav.WIDGETS">Settings</span>
                                </Link>
                            </li>
                        }
                        {/* <li class={_.isEqual(location.pathname, '/data-management') ? 'active' : null}>
                            <Link to="/data-management" title="Widgets">
                                <em class="icon-settings"></em><span data-localize="sidebar.nav.WIDGETS">Data Management</span>
                            </Link>
                        </li> */}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default Index;
